// components/StatsCard.tsx
// Reusable stats card component for metrics display

import React from 'react';
import './StatsCard.css';

interface StatsCardProps {
    title: string;
    value: number | string;
    change?: number;  // Percentage change
    icon?: string;
    color?: 'blue' | 'green' | 'yellow' | 'red' | 'purple';
    subtitle?: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({
    title,
    value,
    change,
    icon,
    color = 'blue',
    subtitle
}) => {
    const formatValue = (val: number | string): string => {
        if (typeof val === 'number') {
            return val.toLocaleString();
        }
        return val;
    };

    return (
        <div className={`stats-card stats-card-${color}`}>
            <div className="stats-card-content">
                <div className="stats-card-header">
                    <span className="stats-card-title">{title}</span>
                    {icon && <span className="stats-card-icon">{icon}</span>}
                </div>

                <div className="stats-card-value">{formatValue(value)}</div>

                {subtitle && (
                    <div className="stats-card-subtitle">{subtitle}</div>
                )}

                {change !== undefined && (
                    <div className={`stats-card-change ${change >= 0 ? 'positive' : 'negative'}`}>
                        <span className="change-arrow">{change >= 0 ? '�' : '�'}</span>
                        <span className="change-value">{Math.abs(change)}%</span>
                        <span className="change-label">vs last period</span>
                    </div>
                )}
            </div>
        </div>
    );
};
